import { DirectiveOptions } from 'vue';
import { getUrlTarget, getRel } from '@/shared/services/link-service';

const directive: DirectiveOptions = {
    bind(el, binding, node) {
        let hrefValue = el.getAttribute('href') || '';

        if (hrefValue) {
            el.setAttribute("target", getUrlTarget(hrefValue));
            el.setAttribute("rel", getRel(hrefValue));
        }
    }
};

export default directive;